import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import ReportOverviewCard from '../ReportOverviewCard';
import noop from '../../utils/noop';
import getQuotaPercentage from '../../utils/getQuotaPercentage';
import hasQuotaData from '../../utils/hasQuotaData';

import { getMonthNameWithPrefix } from '../../utils/dateUtility';
import stripHTML from '../../utils/stripHTML';

class UsersQuotaReportOverviewCard extends Component {
  render() {
    const {
      quotaReportData,
      description,
      descriptionForMixedPlan,
      usersField,
      isAppliance
    } = this.props;

    const { month } = quotaReportData;

    return (
      hasQuotaData(quotaReportData, usersField) ? (
        <ReportOverviewCard
          {...this.props}
          subtitle={getMonthNameWithPrefix(month)}
          description={stripHTML(description)}
          descriptionForMixedPlan={stripHTML(descriptionForMixedPlan)}
          charts={[
            {
              type: `quota${usersField}`,
              quota: get(quotaReportData, ['quota', usersField]),
              currentQuota: get(quotaReportData, ['total', usersField]),
              percentage: get(quotaReportData, ['percentage', usersField]),
              percentageDetails: isAppliance
                ? {
                    appliance: getQuotaPercentage(
                      get(quotaReportData, ['appliance', usersField]),
                      get(quotaReportData, ['quota', usersField])
                    ),
                    cloud: getQuotaPercentage(
                      get(quotaReportData, ['cloud', usersField]),
                      get(quotaReportData, ['quota', usersField])
                    )
                  }
                : null
            }
          ]}
        />
        ) : null);
  }
}

UsersQuotaReportOverviewCard.propTypes = {
  quotaReportData: PropTypes.object,
  contactSales: PropTypes.func,
  contactSalesLink: PropTypes.string,
  isAppliance: PropTypes.bool,
  isMixedPlan: PropTypes.bool,
  handleClick: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  descriptionForMixedPlan: PropTypes.string,
  usersField: PropTypes.string
};

UsersQuotaReportOverviewCard.defaultProps = {
  handleClick: noop,
  quotaReportData: {},
};

export default UsersQuotaReportOverviewCard;
